import { trackPageView, initScrollAnimations } from '../lib';

export function initAdsVerificationPage(): void {
  console.log('Initializing ads verification page');
  initScrollAnimations();
  trackPageView();
}

if (typeof window !== 'undefined') {
  document.addEventListener('DOMContentLoaded', initAdsVerificationPage);
}
